//
//
//
//

export default {
  created() {
    this.$router.push('/measurements/rf/')
  },
}
